import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import router from "@/router";
import { _logout } from "@/api/user";

Vue.use(Vuex);

// const nonPersistPath = ["dashboard.queryFilter"];
const objectPath = require("object-path");

let initState = {
    userHadCard: true,
    userPaymentStatus: true,
    userHasSubscription: false,
    queryGroupName: "",
    allGroupNames: [],
    userAvatar: "blond-curly-hair-business-lady",
    userData: {},
    userPref: {},
    menuState: {},
    frontendConfigs: {},
    userSelectedColumns: {},
    maxRecordLb: {
        a: 0,
        cname: 0,
    },
    // rcmTableIsInitComplete: null,
    socketInfo: { socketId: null, connect: false },
    backendData: {
        thirdParty: { lineOptimize: { regionInfo: [] } },
    },
    chartData: {
        reqlinechart: { datasets: [{ data: [] }] },
        cacheStatusLineChart: { datasets: [{ data: [] }, { data: [] }] },
        edgewaftypelinechart: { datasets: [{ data: [] }] },
    },
    netflowChartData: {
        byteincomingpercentilesnum: { num: null },
        byteincominglinechart: { labels: [], datasets: [] },
        byteincomingmaxnum: { num: null },
        byteincomingminnum: { num: null },
        byteoutgoingpercentilesnum: { num: null },
        byteoutgoinglinechart: { labels: [], datasets: [] },
        byteoutgoingmaxnum: { num: null },
        byteoutgoingminnum: { num: null },
    },
    isNetflowChartLoading: false,
    platformPrefs: {
        functions: {
            appProfile: {
                enterProfileDomainStyle: "a",
            },
            domain: {
                domainWithNoneAppProfile: true,
                canBulkCreate: false,
                cnameInfoStyle: "withText",
                isCnameHintShown: false,
                isEnforceProtectWithPaw: true,
            },
            wafRule: {
                component: "OneListDraggable",
            },
            serviceGroup: {
                isEnforceProtectWithPaw: true,
            },
        },
        pages: {
            LoginPage: {
                images: {
                    loginFormLogoImgName: "/static/prefs/img/login_form_logo.svg",
                    backgroundLogoImgName: "",
                    backgroundImgName: "",
                },
                loginDescription: "CDN Management",
            },
            InnerPage: {
                images: {
                    headerLogoImgName: "/static/prefs/img/header_logo.svg",
                },
                layout: {
                    adminMenuDirection: "vertical",
                    normalUserMenuDirection: "vertical",
                    userWithAvatar: false,
                    languageItems: ["en-US", "zh-TW", "zh-CN"],
                    normalUserConfig: {
                        hasHomePage: false,
                        landingPagePath: "", //only works when `hasHompage: false`
                        groupListWithAll: true,
                    },
                },
            },
        },
        components: {
            Table: {
                withBorder: false,
                withModal: false,
                actionWithIcon: false,
                headerStyle: "hasBackgroundColor",
                fixedColumn: false,
                paginationPosition: "left",
                resizable: false,
            },
            Chart: {
                withRawBtn: true,
                showRawBtnStyle: "iconBtn",
                colorScheme: {
                    blue: "rgba(87, 115, 153,1)",
                    red: "rgba(239, 99, 81,1)",
                    green: "rgba(112, 151, 117,1)",
                    yellow: "rgba(255, 188, 66,1)",
                    darkYellow: "rgba(253, 202, 64,1)",
                    grey: "rgba(153, 153, 161,1)",
                    purple: "rgba(166, 128, 140,1)",
                    orange: "rgba(255, 172, 129,1)",
                    pink: "rgba(234, 201, 193,1)",
                    greyBlue: "rgba(157, 180, 192,1)",
                    brown: "rgba(193, 140, 93,1)",
                },
                legendPointStyle: false,
            },
            Notify: {
                name: "iview-notice",
                position: "bottom left",
            },
            JsonPopTip: {
                withIcon: false,
            },
            Dashboard: {
                dashboardQueryFilter: "V2",
                dashboardWithSearchBtn: false,
                isCircleTCPListBtn: true,
            },
            GlobalMission: {
                isShown: true,
            },
        },
        i18n: {},
        favicon: {
            faviconName: "static/icons/favicon.svg",
        },
        brandTitle: "INODENINJA",
        themeName: "inodeNinja",
        layoutName: "",
        fontFamily: "",
    },
    platformPlan: {
        currentPlan: "basic",
        planSpec: [
            {
                planName: "basic",
                dnsPodPlan: "DP_Free",
                wafActions: ["00", "01", "06", "12", "13"],
                features: [],
                resourceLimits: {},
                packages: {},
            },
        ],
        multiTenancyConfigs: {
            isSupportLicenseSystem: false,
            isAllowDomainPerGroup: false,
            isAllowWildcardDomain: false,
            isAllowOCSP: false,
            isAllowGroupUserRegisterSLB: false,
            isAllowGroupUserRegisterEdge: false,
            isAllowGroupUserChangeUIConfig: false,
            isAllowPaymentShow: false,
            isAllowPaymentType: "stripe",
            webfrontHost: "",
            // isAllowWafOwaspShow: true,
            wafSetting: {},
            isAllowCouponShow: true,
            sslProvider: [],
            sslDefaultProvider: "",
            setNetflowIpList: false,
            isPresentHtmlPageFromLocal: false,
            isPresentHtmlPageFromLocalDefaultValue: false,
            rolePermissionExample: [],
        },
    },
    groupResourceLimits: {},
    dashboardTabList: ["requestSummary", "sampling", "report"],
    dashboard: {
        queryFilter: {
            groupNames: [],
            serviceGroupNames: [],
            appProfileNames: [],
            serverNames: [],
            tags: [],
            origins: [],
            originHosts: [],
            originPorts: [],
            slbNames: [],
            edgeNames: [],
            latencyStatusNames: [],
            dateRangeOptions: {
                index: "1",
                customTimeRange: [],
            },
            creditCardInfo: {},
        },
    },
    creditCard: [],
    userPaymentInfo: {},
    createDate: "",
    paymentSeat: "",
    // trialObjectName: "",
    menuItems: [],
    isPaymentOpened: false,
    failPaymentGroup: "",
    edgeChangeVersionStatus: {},
};
let cloneDeep = (data) => {
    //深度copy一份數據
    return JSON.parse(JSON.stringify(data));
};

const store = new Vuex.Store({
    state: cloneDeep(initState),
    getters: {
        getMenuItems: (state) => {
            return state.menuItems;
        },
        getUserCreditCardInfo: (state) => {
            return state.creditCard;
        },
        getUserPaymentInfo: (state) => {
            return state.userPaymentInfo;
        },
        isAdmin: (state) => state.userData.privilege == "admin",
        landingPagePath: (state) => {
            // admin 一律去home
            if (state.userData.privilege == "admin") return "/home";

            // nUser 沒設定, 去home
            if (!state.platformPrefs.pages.InnerPage.layout.normalUserConfig.landingPagePath) return "/home";

            // 其餘依照設定
            return state.platformPrefs.pages.InnerPage.layout.normalUserConfig.landingPagePath;
        },
        chartData_reqsumnum: (state) => {
            return state.chartData.reqlinechart.datasets[0].data.reduce((a, b) => a + b, 0);
        },
        chartData_servedsumnum: (state) => {
            if (state.chartData.cacheStatusLineChart.datasets.length > 0) {
                return state.chartData.cacheStatusLineChart.datasets[1].data.reduce((a, b) => a + b, 0);
            } else {
                return [];
            }
        },
        chartData_wafsumnum: (state) => {
            let datasetsMerged = state.chartData.edgewaftypelinechart.datasets.map((dataset) => dataset.data);
            datasetsMerged = [].concat.apply([], datasetsMerged);
            let sumNum = datasetsMerged.reduce((a, b) => a + b, 0);
            return sumNum;
        },
        chartData_cacheStatusPieChart: (state) => {
            let cachedSum = state.chartData.cacheStatusLineChart.datasets[0].data.reduce((a, b) => a + b, 0);
            let servedSum = state.chartData.cacheStatusLineChart.datasets[1].data.reduce((a, b) => a + b, 0);
            let unCachedSum = servedSum - cachedSum;
            return { data: { datasets: [{ data: [cachedSum, unCachedSum] }], labels: ["cached", "uncached"] } };
        },
        chartData_cacheRatioSeries: (state) => {
            const cachedDataset = state.chartData.cacheStatusLineChart.datasets[0];
            const servedDataset = state.chartData.cacheStatusLineChart.datasets[1];
            const cached = cachedDataset ? cachedDataset.data : [];
            const served = servedDataset ? servedDataset.data : [];
            const cachedRatio = {
                data: {
                    datasets: [
                        {
                            data: cached.map((value, index) => {
                                const denominator = served[index];
                                return !denominator ? 0 : value / denominator;
                            }),
                            label: "Cached Ratio",
                        },
                    ],
                    labels: state.chartData.cacheStatusLineChart.labels || [],
                },
            };
            return cachedRatio;
        },
        chartData_cacheRatio: (state, getters) => {
            const data = getters.chartData_cacheStatusPieChart.data.datasets[0].data;
            const cached = data[0];
            const uncached = data[1];
            const sum = cached + uncached;
            return sum === 0 ? 0 : cached / sum;
        },
        chartData_waftypepiechart: (state) => {
            let labels = state.chartData.edgewaftypelinechart.datasets.map((dataset) => dataset.label);
            let data = state.chartData.edgewaftypelinechart.datasets.map((dataset) =>
                dataset.data.reduce((a, b) => a + b, 0)
            );
            return { data: { datasets: [{ data: data }], labels: labels } };
        },
        netflowChartData_num: (state) => (chartType) => {
            return state.netflowChartData[chartType].num;
        },
        netflowChartData_lineChart: (state) => (chartType) => {
            return {
                data: state.netflowChartData[chartType],
            };
        },
        resourceLimits: (state) => {
            let { currentPlan } = state.platformPlan;
            let planData = state.platformPlan.planSpec.find((e) => e.planName == currentPlan);
            return planData.resourceLimits;
        },
        currentGroupResourceLimits: (state) => {
            let currentGroupResourceLimits = state.groupResourceLimits[state.queryGroupName];
            return currentGroupResourceLimits || {};
        },
        currentGroupRolePermissions: (state) => {
            let currentGroupRoleData = state.userData.inGroupsRole.find((e) => e.groupName == state.queryGroupName);
            return currentGroupRoleData ? currentGroupRoleData.rolePermissions : [];
        },
        features: (state) => {
            let { currentPlan } = state.platformPlan;
            let planData = state.platformPlan.planSpec.find((e) => e.planName == currentPlan);
            return planData.features;
        },
        inGroupNames: (state) => {
            if (!state.userData.privilege) return [];
            let isAdmin = state.userData.privilege == "admin";
            let groupListWithAll = state.platformPrefs.pages.InnerPage.layout.normalUserConfig.groupListWithAll;
            let inGroupNames =
                state.userData.privilege == "admin"
                    ? state.allGroupNames
                    : state.userData.inGroupsRole.map((e) => e.groupName);

            if (isAdmin || (groupListWithAll && inGroupNames.length > 1)) return ["all", ...inGroupNames];
            return inGroupNames;
        },
        hasMultiGroups: (state, getters) => {
            let userGroups = getters.inGroupNames.filter((groupName) => groupName !== "all");
            return userGroups.length > 1;
        },
        getNormalUserConfig: (state) => {
            return state.platformPrefs.pages.InnerPage.layout.normalUserConfig;
        },
        getLoginPageImgs: (state) => {
            return state.platformPrefs.pages.LoginPage.images;
        },
        getLoginDescription: (state) => {
            let loginDescrp = state.platformPrefs.pages.LoginPage.loginDescription;
            return loginDescrp;
        },
        getInnerPageImg: (state) => {
            return state.platformPrefs.pages.InnerPage.images;
        },
        getMenuDirection: (state) => {
            if (state.userData.privilege == "admin") {
                return state.platformPrefs.pages.InnerPage.layout.adminMenuDirection;
            } else if (state.userData.privilege == "normaluser") {
                return state.platformPrefs.pages.InnerPage.layout.normalUserMenuDirection;
            }
        },
        getNotificationName: (state) => {
            return state.platformPrefs.components.Notify.name;
        },
        getNotificationPosition: (state) => {
            return state.platformPrefs.components.Notify.position;
        },
        getUserWithAvatar: (state) => {
            return state.platformPrefs.pages.InnerPage.layout.userWithAvatar;
        },
        getLanguageItems: (state) => {
            return state.platformPrefs.pages.InnerPage.layout.languageItems;
        },
        getChartConfig: (state) => {
            return state.platformPrefs.components.Chart;
        },
        getTableConfig: (state) => {
            return state.platformPrefs.components.Table;
        },
        getJsonPopTipConfig: (state) => {
            return state.platformPrefs.components.JsonPopTip;
        },
        getDashboardConfig: (state) => {
            return state.platformPrefs.components.Dashboard;
        },
        getDomainConfig: (state) => {
            return state.platformPrefs.functions.domain;
        },
        getWafRuleComponent: (state) => {
            return state.platformPrefs.functions.wafRule.component;
        },
        getServiceGroupConfig: (state) => {
            return state.platformPrefs.functions.serviceGroup;
        },
        getFontFamily: (state) => {
            return state.platformPrefs.fontFamily;
        },
        getAppProfileConfig: (state) => {
            return state.platformPrefs.functions.appProfile;
        },
        getBrandName: (state) => {
            return state.platformPrefs.brandTitle;
        },
        isGlobalMissionShown: (state) => {
            return state.platformPrefs.components.GlobalMission.isShown;
        },
        getQueryGroupName: (state) => {
            return state.queryGroupName;
        },
        isInAllGroupView: (state) => {
            return state.queryGroupName == "all";
        },
    },
    mutations: {
        SET_EDGE_UPGRADE_STATUS: (state, { hostname, status }) => {
            state.edgeChangeVersionStatus[hostname] = status;
        },
        SET_FAIL_PAYMENT_GROUP: (state, data) => {
            state.failPaymentGroup = data;
        },
        SET_isPaymentOpened: (state, data) => {
            state.isPaymentOpened = data;
        },
        SET_paymentSeat: (state, data) => {
            state.paymentSeat = data;
        },
        SET_MENU_ITEMS: (state, data) => {
            state.menuItems = data;
        },
        // SET_TRIAL_OBJECTNAME: (state, data) => {
        //     state.trialObjectName = data;
        // },
        SET_USER_HAS_CARD: (state, data) => {
            state.userHadCard = data;
        },
        SET_USER_HAS_SUBSCRIPTION: (state, data) => {
            state.userHasSubscription = data;
        },
        SET_USER_PAYMENT_STATUS: (state, data) => {
            state.userPaymentStatus = data;
        },
        SET_USER_PAYMENT_INFO: (state, data) => {
            state.userPaymentInfo = data;
        },
        SET_CREDIT_CARD_INFO: (state, data) => {
            state.creditCardInfo = data;
        },
        SET_USER_CREATE_DATE: (state, data) => {
            state.createDate = data;
        },
        LOGOUT(state) {
            Object.assign(state, initState); //用原數據進行還原
        },
        SET_QUERY_GROUPNAME: (state, data) => {
            state.queryGroupName = data;
            // state.dashboard.queryFilter.groupNames = data == 'all' ? [] : [data];
            state.dashboard.queryFilter = {
                groupNames: data == "all" ? [] : [data],
                serviceGroupNames: [],
                appProfileNames: [],
                serverNames: [],
                tags: [],
                origins: [],
                originHosts: [],
                originPorts: [],
                slbNames: [],
                edgeNames: [],
                latencyStatusNames: [],
                dateRangeOptions: {
                    index: "1",
                    customTimeRange: [],
                },
            };
        },
        SET_ALL_GROUPNAMES: (state, data) => {
            state.allGroupNames = data;
        },
        SET_USER_AVATAR: (state, data) => (state.userAvatar = data),
        SET_USER_DATA: (state, data) => (state.userData = data),
        SET_USER_DATA_ISNEEDTOVALIDATE: (state, data) => (state.userData.validateNewEquip.isNeedToValidate = data),
        SET_USER_PREF: (state, data) => (state.userPref = data),
        // SET_USER_MENU: (state, data) => (state.menuState = data),
        SET_FRONTEND_CONFIGS: (state, data) => (state.frontendConfigs = data),
        SET_MAX_A_RECORDS_LB: (state, data) => (state.maxRecordLb.a = data),
        SET_MAX_CNAME_RECORDS_LB: (state, data) => (state.maxRecordLb.cname = data),
        SET_GROUP_RESOURCE_LIMITS: (state, data) => {
            let { groupName, groupResourceLimits } = data;
            state.groupResourceLimits[groupName] = groupResourceLimits;
        },
        SET_SELECTED_COLUMNS: (state, data) => {
            state.userSelectedColumns[data.view] = data.data;
        },
        SET_REGION_INFO: (state, data) => (state.backendData.thirdParty.lineOptimize.regionInfo = data),
        SET_CHART_DATA: (state, data) => (state.chartData[data.chartName] = data.data),
        SET_NETFLOW_CHART_DATA: (state, payload) => {
            state.netflowChartData = {
                ...state.netflowChartData,
                ...payload.data,
            };
        },
        SET_NETFLOW_CHART_LOADING(state, status) {
            state.isNetflowChartLoading = status;
        },
        SET_PLATFORM_PREFS: (state, data) => (state.platformPrefs = data),
        SET_I18N: (state, data) => (state.platformPrefs.i18n = data),
        SET_PLATFORM_PLAN: (state, data) => (state.platformPlan = data),
        SET_DASHBOARD_TAB_LIST: (state, data) => (state.dashboardTabList = data),
        SET_DASHBOARD_QUERY_FILTER: (state, { key, value }) => {
            // state.dashboard.queryFilter[key] = value;
            // for dot notations
            objectPath.set(state.dashboard.queryFilter, key, value);
        },
        SET_DASHBOARD_QUERY_FILTER_FULL: (state, queryFilter) => {
            // 淺拷貝, 注意timerange不受此拷貝影響
            state.dashboard.queryFilter = Object.assign({}, queryFilter);
        },
        // socket io
        SOCKET_connect: (state) => (state.socketInfo.connect = true),
        SOCKET_disconnect: (state) => {
            state.socketInfo.connect = false;
            state.socketInfo.socketId = null;
        },
        SOCKET_updateSocketId: (state, socketId) => (state.socketInfo.socketId = socketId),

        SOCKET_kickUser: async (state, socketId) => {
            _logout()
                .then((response) => {
                    router.push({ name: "login" });
                })
                .catch((errors) => {});
        },
        RESET_DASHBOARD_QUERY_FILTER: (state, data) => {
            state.dashboard.queryFilter = {
                groupNames: data,
                serviceGroupNames: [],
                appProfileNames: [],
                serverNames: [],
                tags: [],
                origins: [],
                originHosts: [],
                originPorts: [],
                slbNames: [],
                edgeNames: [],
                latencyStatusNames: [],
                dateRangeOptions: {
                    index: "1",
                    customTimeRange: [],
                },
            };
        },
        SET_CREDITCARD: (state, data) => {
            state.creditCard.push(data);
        },
        RESET_CREDITCARD: (state, data) => {
            // state.creditCard = [...new Set(state.creditCard.push(data))];
            state.creditCard = state.creditCard.filter((e) => {
                return e != data;
            });
        },
    },
    actions: {},
    plugins: [
        createPersistedState({
            paths: [
                "queryGroupName",
                "allGroupNames",
                "userData",
                "userPref",
                // "menuState",
                "frontendConfigs",
                "userSelectedColumns",
                "maxRecordLb",
                // "rcmTableIsInitComplete",
                "socketInfo",
                "backendData",
                // "platformPrefs",
                "platformPlan",
                "dashboardTabList",
                // "dashboard",
                // "currentGroupName",
                // "chartData",
                // "frontendOptions",
                "userAvatar",
                "creditCard",
                "userPaymentInfo",
                "isPaymentOpened",
                "failPaymentGroup",
                "edgeChangeVersionStatus",
            ],
        }),
    ],
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js